import { Cell, Grid, HFlow, Icon, Text, VFlow } from 'bold-ui'
import { Color } from 'csstype'
import React from 'react'
import { ListagemGestantePuerperaAtendimentosModel } from 'view/acompanhamento/acompanhamento-condicao-saude/model/lista-tematica/model-gestantePuerpera'

export interface AcompanhamentoCondicaoSaudeGestantePuerperaConsultasPuerperioSectionProps {
  atendimentosPreNatalPuerperio: ListagemGestantePuerperaAtendimentosModel
  iconColor?: Color
}

export function AcompanhamentoCondicaoSaudeGestantePuerperaConsultasPuerperioSection({
  atendimentosPreNatalPuerperio,
  iconColor,
}: Readonly<AcompanhamentoCondicaoSaudeGestantePuerperaConsultasPuerperioSectionProps>) {
  return (
    <Grid gap={1} gapVertical={0.5} alignItems='baseline'>
      <Cell size={12}>
        <HFlow hSpacing={0.5} alignItems='center'>
          <Icon width='1rem' icon='nurse' color={iconColor} />
          <Text fontWeight='bold'>Puerpério</Text>
        </HFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>Consultas</Text>
          <Text>{atendimentosPreNatalPuerperio?.consultasPuerperio ?? 0}</Text>
        </VFlow>
      </Cell>
    </Grid>
  )
}
